import React from 'react';
import PropTypes from 'prop-types';
import MenuItem from 'material-ui/MenuItem';
import translate from 'components/hoc/translate';
import { Link } from 'react-router-dom';

const EditAction = (props) => {
    const { fullPath, record, resource, translate, url } = props;

    const buildLink = () => {
        const defaultLink = `${ resource }/${ record.id }`;
        let link = defaultLink;

        if (url) {
            link = url;
        }

        if (fullPath) {
            link = `/${ link }`;
        }

        return link;
    };

    return (
        <MenuItem
            containerElement={
                <Link to={ buildLink() } />
            }
            primaryText={ translate('actions.edit') }
        />
    );
};

EditAction.defaultProps = {
    fullPath: false,
};

EditAction.propTypes = {
    fullPath: PropTypes.bool,
    record: PropTypes.object,
    resource: PropTypes.string,
    translate: PropTypes.func.isRequired,
    url: PropTypes.string,
};

export default translate(EditAction);



// WEBPACK FOOTER //
// ./src/components/field/DropDownActionsMenu/EditAction.js